
$(document).ready(function () {
    $("#password").on('keyup', function(){
        const number = /([0-9])/;
        const alphabets = /([a-zA-Z])/;
        const special_characters = /([~,!@#$%^&*-_+=?><])/;
        const passwordField = $('#password');
        const strengthStatus = $('#password-strength-status');
        if (passwordField.val().length < 6) {
            strengthStatus.removeClass('strong-password');
            strengthStatus.removeClass('medium-password');
            strengthStatus.addClass('weak-password');
            //strengthStatus.html("Weak (should be atleast 6 characters.)");
        } else {
            if (passwordField.val().match(number) && passwordField.val().match(alphabets) && passwordField.val().match(special_characters)) {
                strengthStatus.removeClass('weak-password');
                strengthStatus.removeClass('medium-password');
                strengthStatus.addClass('strong-password');
                //strengthStatus.html("Strong");
            } else {
                strengthStatus.removeClass('strong-password');
                strengthStatus.removeClass('weak-password');
                strengthStatus.addClass('medium-password');
                //strengthStatus.html("Medium (should include alphabets, numbers and special characters or some combination.)");
            }
        }
    });
});